import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useLocation } from 'react-router-dom';
import { S_Tab } from '../../../../design/tabs/tab/S_Tab';
import { S_TabsContainer } from '../../../../design/tabs/tabsContainer/S_TabsContainer';
import { Home } from '../../../routes/config/Home';

interface IProps {
  workspaceId: string;
}

export const ProjectsTabs = observer((props: IProps): ReactElement => {
  const { workspaceId } = props;
  const { t } = useTranslator();
  const { pathname } = useLocation();

  return (
    <S_TabsContainer>
      <S_Tab
        text={t('all_projects')}
        link={Home.Projects.List.All.withParams({ workspaceId })}
        state={pathname.includes('all') ? 'active' : 'passive'}
      />
      <S_Tab
        text={t('my_projects')}
        link={Home.Projects.List.Owned.withParams({ workspaceId })}
        state={pathname.includes('owned') ? 'active' : 'passive'}
      />
      <S_Tab
        text={t('other_projects')}
        link={Home.Projects.List.Others.withParams({ workspaceId })}
        state={pathname.includes('others') ? 'active' : 'passive'}
      />
    </S_TabsContainer>
  );
});
